import { type ERPItem } from '../../../integration/ERPItem'
import { type APIConfig } from '../apiTypes'
import { axiosInstance } from './axiosInstance'

const axios = axiosInstance()

interface Response {
  // This is where dimensions, constraints and presets come from -- not from Scensum
  list: ERPItem[]
  // The shape is unknown and therefore left uninterpreted. A non-empty list only means
  // LFC could not deliver data for at least one mallis.
  errorlist: any[]
}

export const postLfcInitList = async <T = any>(args: {
  apiConfigs: APIConfig
  data: {
    list: any[]
  }
  onSuccess: (response: { data: Response }) => T
}): Promise<T> => {
  const { onSuccess } = args
  const { marketCode, lfcApiBaseUrl } = args.apiConfigs
  const { list } = args.data

  return await axios<Response>({
    method: 'post',
    url: `${lfcApiBaseUrl}/multimallis/initlistbycontext`,
    params: {
      marketCode,
      useCache: true,
    },
    data: {
      list,
    },
  })
    .then((response) => onSuccess(response))
    .catch((error) => {
      console.error(error)
      throw new Error(JSON.stringify(error))
    })
}
